var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
        'has-error': _vm.$parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_ACTUAL_TECH_ID'
        )
      }},[_c('tags-input',{attrs:{"element-id":"tags","existing-tags":_vm.tags,"only-existing-tags":true,"placeholder":"Добавить объект","typeahead":true,"disabled":_vm.$parent.$parent.projectDisabled},on:{"tag-added":_vm.onTagAdded,"tag-removed":_vm.onTagRemoved,"tags-updated":function($event){return _vm.$parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_ACTUAL_TECH_ID'
          )}},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n        "+_vm._s(_vm.$parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_ACTUAL_TECH_ID"
          ))+"\n      ")])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }